import { gql } from '@apollo/client';
import { FraudToolDetails } from '../types/fraudToolDetails';
import performQuery from './contentfulClient';

export const FRAUD_TOOL_DETAILS_QUERY = gql`
  query fraudToolDetailsQuery($slug: String!) {
    anFraudToolDetailsCollection(where: { slug: $slug }, limit: 1) {
      items {
        slug
        toolName
        details {
          json
        }
        underwriter1
        underwriter1Price
        underwriter1Details {
          json
        }
        underwriter2
        underwriter2Price
        underwriter2Details {
          json
        }
      }
    }
  }
`;

export const useFraudToolDetailsQuery = async (slug: string) => {
  const response = await performQuery(FRAUD_TOOL_DETAILS_QUERY, { slug });

  if (response.hasError) {
    return {
      data: null,
      error: true,
      errorMsg: response.error,
    };
  }

  return {
    data: response.res?.data?.anFraudToolDetailsCollection?.items?.[0] as FraudToolDetails | null,
    error: false,
  };
};
